import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    maxHeight: "calc(100dvh - 64px)",
    overflow: "auto",
    position: "relative"
  },
  leftFixedColumns: {
    height: "100%",
    boxShadow: "2px 0px 7px 0px rgba(0, 0, 0, 0.15)",
    position: "sticky",
    display: "flex",
    flexDirection: "column",
    zIndex: 1
  },
  scrollableContent: {
    display: "grid",
    gridTemplateColumns: `
        90px 90px 81px 81px 51px 51px 51px 51px 51px 51px 51px 51px
        90px 81px 81px 51px 51px 51px 51px 51px 51px 51px 51px
      `,
    maxWidth: "calc(100vw - 510px)",
    overflowX: "auto",
    marginBottom: -9,
    [theme.breakpoints.down(Breakpoints.MD_960)]: {
      maxWidth: "calc(100vw - 374px)"
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      maxWidth: "calc(100vw - 290px)"
    },
    borderRight: "1px solid",
    position: "relative"
  },
  rowContent: {
    display: "flex"
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    gap: 2
  },
  colorGroupFixedCells: {
    display: "grid",
    gridTemplateColumns: "127px 161px",
    gridGap: 2
  },
  cell: {
    height: 56,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 12
  },
  dirtDashedBorder: {
    position: "relative",
    "&:before": {
      display: "block",
      content: "''",
      borderLeft: "2px solid #de7d16",
      height: 36,
      position: "absolute",
      left: 0
    }
  },
  turfAndSyntheticDashedBorder: {
    position: "relative",
    "&:before": {
      display: "block",
      content: "''",
      borderLeft: "2px solid #1a8c00",
      height: 36,
      position: "absolute",
      left: 0
    }
  },
  divider: {
    height: "100%",
    borderLeft: "1px solid",
    position: "absolute",
    zIndex: 1
  },
  horseNumberDivider: {
    left: 90
  },
  surfaceDivider: {
    left: 750
  }
}));
